import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)
Vue.http.options.root = process.env.API_URL

export const QueryLastest = Vue.resource('latest')
export const QueryComponents = Vue.resource('components')
export const QueryIncidents = Vue.resource('incidents?componentId={componentId}')
export const QueryIncident = Vue.resource('incidents{/id}')
export const QueryReport = Vue.resource('report')
export const QueryStatus = Vue.resource('status')
export const QueryMessages = Vue.resource('messages{/id}')



// WEBPACK FOOTER //
// ./src/resource/index.js